import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

const hrModule: ModuleManifest = {
  id: 'P9',
  name: 'HR',
  shortName: 'HR',
  description: 'Employee lifecycle management, onboarding, payroll, and compliance',
  icon: '👤',
  status: 'live',
  urlPrefix: '/hr',
  routes,
  navItems,
  collections: {
    EMPLOYEES: 'employees',
    POLICIES: 'policies',
    ONBOARDING_TEMPLATES: 'onboardingTemplates',
    ONBOARDING_CHECKLISTS: 'onboardingChecklists',
    BACKGROUND_CHECK_PACKAGES: 'backgroundCheckPackages',
    HR_AUDIT_LOG: 'hrAuditLog',
    CREDENTIAL_TYPES: 'credentialTypes',
  },
};

export default hrModule;
